var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipLocatorLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 195,
    viewBox: "0 0 169 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2801_11458)",
    id: "g19",
    transform: "translate(-238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 288,13.5 263.5,41 249,77 l 10.5,38 64.5,69 28,-28 31,-29.5 16,-35.5 -10,-39 -9.5,-20 -20,-16 -23,-9 H 317 Z",
    fill: "#f7f7f7",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 365.904,80.6242 -13.298,42.7908 c -0.149,0.866 -0.945,1.045 -2.02,1.443 l -26.168,9.585 -25.014,-9.585 c -0.945,-0.398 -1.732,-0.577 -2.02,-1.593 L 284.086,80.4749 c -0.14,-0.5773 -0.14,-1.1546 0.139,-1.7319 0.289,-0.5773 0.727,-0.866 1.304,-1.0153 l 38.889,-9.8341 c 0.288,-0.1394 0.726,-0.1394 1.015,0 l 38.889,9.8341 c 0.577,0.1394 1.015,0.5773 1.304,1.0153 0.288,0.438 0.577,1.3039 0.288,1.8812 z",
    fill: "#061657",
    id: "path4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2801_11458",
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 67,
    width: 84,
    height: 68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 297.374,123.275 284.076,80.4849 c -0.14,-0.5773 -0.14,-1.1546 0.139,-1.7319 0.289,-0.5773 0.727,-0.866 1.304,-1.0153 l 38.889,-9.8341 c 0.288,-0.1394 0.726,-0.1394 1.015,0 l 38.889,9.8341 c 0.577,0.1394 1.015,0.5774 1.304,1.0153 0.288,0.438 0.577,1.3039 0.288,1.8812 l -13.298,42.7908 c -0.149,0.866 -0.995,1.065 -2.02,1.443 l -26.168,9.585",
    fill: "#ffffff",
    id: "path6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 324.985,63.5638 c 0.577,0 1.015,0 1.592,0.1394 l 30.07,7.6642 V 54.4563 c 0,-1.1547 -1.015,-2.1699 -2.17,-2.1699 h -58.985 c -1.154,0 -2.169,1.0152 -2.169,2.1699 v 16.9211 l 30.069,-7.6643 c 0.578,-0.1493 1.016,-0.1493 1.593,-0.1493 z",
    fill: "#0297cc",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 347.689,40.2922 c 0,-1.1546 -1.015,-2.1699 -2.17,-2.1699 h -41.058 c -1.155,0 -2.17,1.0153 -2.17,2.1699 v 7.6643 h 45.398 z",
    fill: "#061657",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 382.796,24.6849 -6.012,-5.4346 C 362.291,6.79831 344.026,0 324.716,0 305.406,0 287.141,6.79831 272.649,19.2503 l -5.455,5.4346 c -14.343,14.9603 -22.216,34.539 -22.216,55.3321 0,36.669 30.836,66.59 58.039,92.987 6.351,6.161 12.343,11.974 17.728,17.657 l 4.25,4.479 4.25,-4.479 c 5.385,-5.683 11.387,-11.506 17.728,-17.667 27.203,-26.397 58.039,-56.308 58.039,-92.987 0,-20.793 -7.873,-40.3718 -22.216,-55.332 z M 338.831,164.603 c -4.838,4.688 -9.466,9.187 -13.826,13.616 -4.36,-4.429 -8.988,-8.928 -13.826,-13.616 -25.541,-24.785 -54.486,-52.864 -54.486,-84.586 0,-17.7871 6.839,-34.0115 18.016,-46.1748 l 5.395,-5.5043 c 11.974,-10.3517 27.582,-16.6325 44.622,-16.6325 17.041,0 32.638,6.2708 44.622,16.6325 l 5.953,5.5043 c 11.177,12.1733 18.016,28.3877 18.016,46.1748 0,31.722 -28.946,59.801 -54.486,84.586 z",
    fill: "#0297cc",
    id: "path17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs24"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2801_11458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 281.74701,
    fill: "#ffffff",
    id: "rect21",
    x: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipLocatorLogo);
export default __webpack_public_path__ + "static/media/ship-locator-logo.ee7af75c091f42c00dcc9212463bca3f.svg";
export { ForwardRef as ReactComponent };